import { useState } from "react";
import HealthAnalytics from "@/components/health/HealthAnalytics";
import GpsWeekCard from "@/components/health/GpsWeekCard";

export default function FamilyHealth({ family, meId }) {
  const others = family.members.filter((m) => m.id !== meId);
  const [sel, setSel] = useState(others[0]?.id || meId);
  const memberParam = sel === meId ? "" : sel;
  return (
    <div className="space-y-4" data-testid="family-health">
      <div className="flex items-center gap-2 flex-wrap">
        {family.members.map((m) => (
          <button key={m.id} onClick={() => setSel(m.id)} data-testid={`fh-member-${m.id}`}
            className={`px-3 py-1.5 rounded-full text-xs font-semibold transition-colors ${sel === m.id ? "bg-primary text-white" : "bg-secondary text-muted-foreground hover:text-foreground"}`}>
            {m.name}{m.id === meId ? " (вы)" : ""}
          </button>
        ))}
      </div>
      <GpsWeekCard key={`gps-${sel}`} member={memberParam} />
      <HealthAnalytics key={sel} member={memberParam} />
    </div>
  );
}
